<template>
    <v-container grid-list text-center>
        <v-flex xs12>
            <v-card dark color="primary" v-if="users == null || users.length == 0">
                <div class="d-flex flex-no-wrap justify-space-between">
                    <v-card-title>{{ labelNotFound }}</v-card-title>
                </div>
            </v-card>
            <v-layout wrap v-else>
                <v-flex xs12 class="ma-0 pa-0">
                    <p class="font-weight-black">{{ labelSelect }}</p>
                </v-flex>
                <v-flex xs12 class="my-0 py-0">
                    <v-text-field :label="$t('Filtrar...')" v-model="filterName" clearable hide-details/>
                </v-flex>
                <v-flex xs12 v-for="item of listWithFilter" :key="item.id" class="ma-2">
                    <v-btn color="success" class="mx-auto" width="100%" @click="$emit('selected', item)">
                        {{ item.name }} ({{ item.email }})
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-container>
</template>

<script>

export default {
    name: "UserList",

    props: {
        endpoint: {
            type: String,
            required: true,
        },
        labelNotFound: {
            type: String,
            default: "Não foi localizado nenhum usuário.",
        },
        labelSelect: {
            type: String,
            default: "Selecione abaixo o usuário:",
        },
    },

    data() {
        return {
            filterName: null,
            users: [],
        };
    },

    mounted() {
        this.getStores();
    },

    computed: {
        listWithFilter() {
            let ret = this.users;
            if (this.filterName) {
                let exp = new RegExp(this.filterName.trim().normalize("NFD").replace(/[\u0300-\u036f]/g, ""), "i");
                ret = ret.filter(
                    (item) => typeof item === "object" && item !== null && exp.test(JSON.stringify(Object.values(item)).normalize("NFD").replace(/[\u0300-\u036f]/g, ""))
                );
            }
            return ret;
        },
    },

    methods: {
        getStores() {
            this.$http
                .get(this.endpoint)
                .then((result) => {
                    if (result) {
                        this.users = result;
                    }
                })
                .catch(() => {
                    this.users = [];
                });
        },
    },
};
</script>